<template>
    <Dialog v-model:open="opened">
        <DialogTrigger>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[400px]">
            <DialogHeader class="items-center">
                <DialogTitle>
                    {{ $t("profile.information.update_modal.title") }}
                </DialogTitle>

                <DialogDescription>
                    {{ $t("profile.information.update_modal.description") }}
                </DialogDescription>
            </DialogHeader>

            <div class="px-6 pt-7">
                <div class="gap-2 flex">
                    <Checkbox
                        :checked="true"
                        :disabled="true"
                        class="mt-0.5"
                    ></Checkbox>

                    <Label>
                        <p class="font-medium tracking-normal text-iron-700">
                            {{
                                $t(
                                    "profile.information.update_modal.update_profile_photo_title",
                                )
                            }}
                        </p>
                        <p class="font-normal text-iron-500 tracking-[-0.01em]">
                            {{
                                $t(
                                    "profile.information.update_modal.update_profile_photo_description",
                                )
                            }}
                        </p>
                    </Label>
                </div>
                <div class="mt-6 gap-2 flex">
                    <Checkbox
                        id="with-event-types"
                        v-model:checked="withEventTypes"
                        class="mt-0.5"
                    ></Checkbox>

                    <Label for="with-event-types">
                        <p class="font-medium tracking-normal text-iron-700">
                            {{
                                $t(
                                    "profile.information.update_modal.update_event_types_title",
                                )
                            }}
                        </p>
                        <p class="font-normal text-iron-500 tracking-[-0.01em]">
                            {{
                                $t(
                                    "profile.information.update_modal.update_event_types_description",
                                )
                            }}
                        </p>
                    </Label>
                </div>
            </div>
            <DialogFooter class="w-full justify-end">
                <DialogClose>
                    <Button variant="outline" type="button">{{
                        $t("cancel")
                    }}</Button>
                </DialogClose>

                <Button
                    type="button"
                    @click="emit('confirm', { withEventTypes })"
                >
                    {{ $t("save") }}</Button
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog-v2";
import DialogDescription from "@/components/ui/dialog-v2/DialogDescription.vue";

import { Label } from "@/components/ui/label";
import { ref } from "vue";

const emit = defineEmits(["confirm"]);

const withEventTypes = ref(false);
const opened = defineModel<boolean>({ default: true });
</script>

<style></style>
